export default "__VITE_ASSET__CwRBT1yW__"